import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Fornecedor } from '../model/Fornecedor';
import { Equipamento } from '../model/Equipamentos';

@Injectable({
  providedIn: 'root'
})
export class EquipamentoService {

  private BASE_URL = './rest/equipamento';

  constructor(private http: HttpClient) {
  }

  obterFornecedores(idPac: number): Observable<Fornecedor[]> {
    return this.http.get<Fornecedor[]>(`${this.BASE_URL}/fornecedor/busca-por-id-pac/${idPac}`, blockUi()).pipe();
  }

  obterEquipamentos(idPac: number): Observable<Equipamento[]> {
    return this.http.get<Equipamento[]>(`${this.BASE_URL}/equipamento/busca-por-id-pac/${idPac}`, blockUi()).pipe();
  }

}
